import React from 'react';
import PropTypes from 'prop-types';

import { IconComponent } from '../../atoms/icons/iconComponent';

const renderCoins = (coins) => {
  if (coins != null && coins > 0) {
    return (<span className="text-xl">{coins} coins</span>);
  }
  return null;
};

const CoinBadge = ({
  children, coins, className, loyalty, lang, loggedUser, showURL,
}, context) => {
  let loyaltyUrl = null;

  if (typeof coins === 'undefined' || coins === null) {
    return null;
  }

  if (loyalty) {
    const activeLoaylty = loyalty && loyalty.loyalty_active;
    const disabledComponent = !activeLoaylty;
    if (disabledComponent) {
      return null;
    }

    const registerUrlLang = loyalty[`loyalty_register_url_${lang}`];
    const registerUrl = loyalty.loyalty_register_url;
    loyaltyUrl = registerUrlLang || registerUrl;
  }
  return (
  <div
    className={`text-primary font-bold leading-tight shadow ${
      className || ''
    }`}
  >
    <IconComponent icon={loyalty.loyalty_name === 'M4U' ? 'm4u-loyalty' : 's4u-loyalty'} className="text-4xl"/>
    <div className="ml-1 mt-1">
      {renderCoins()}
      {children && <p className="text-gray-500 text-sm font-medium">{children}</p>}
      {!loggedUser && loyaltyUrl && showURL && <div className="text-sm">
        <a target="_blank" href={loyaltyUrl} rel="noreferrer">{context.t('Click here to register now')}</a>
        {context.t('and get 20 extra coins to use during your stay')}
      </div>}
    </div>
  </div>
  );
};

CoinBadge.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CoinBadge;
